"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var addLanguageSufixToRouteName = function addLanguageSufixToRouteName(sufix) {
  return function (routeName) {
    return routeName + sufix.replace("/", "");
  };
};
var _default = addLanguageSufixToRouteName;
exports["default"] = _default;